import { IoMdClose } from "react-icons/io";
import "./ToastNotification.css";
import { RemoveToastNotification } from "../../Services/ToastNotification/ToastNotificationManager";

const ToastNotification = ({text, type, index}) => {

    const boxClass = type == 0 ? "toastNotificationError" : "toastNotificationSuccess";

    return (
        <div className={'toastNotification ' + boxClass}>
            <div className='toastNotificationText'>{text}</div>
            <div className="toastNotificationButtonContainer">
                <IoMdClose size={"25px"} onClick={() => RemoveToastNotification(index)} className='toastNotificationCloseButton' />
            </div>
        </div>
    );
}

export default ToastNotification;